/**
 * Etiquetas de estado de inventario almacén/sucursal (solo UI).
 * El API sigue usando UNASSIGNED / ASSIGNED.
 */
export const INV_STATUS_WAREHOUSE_LABEL = 'En almacén';
export const INV_STATUS_BRANCH_LABEL = 'En sucursal';

/** Etiqueta UI para tránsito (traslado en curso). */
export const INV_STATUS_TRANSIT_LABEL = 'En tránsito';

/** Etiqueta UI para availabilityStatus IN_REQUEST. */
export const INV_AVAILABILITY_IN_REQUEST_LABEL = 'En solicitud';

/** Etiqueta UI para availabilityStatus RESERVED (API sin cambios). */
export const INV_AVAILABILITY_BLOCKED_LABEL = 'Bloqueada';

/** Pieza dada de baja (availabilityStatus CANCELLED en API; no confundir con registro/transferencia cancelada). */
export const INV_AVAILABILITY_WRITE_OFF_LABEL = 'Baja';
export const INV_AVAILABILITY_WRITE_OFF_LABEL_PLURAL = 'Bajas';

export const isAvailabilityWrittenOff = (availability: string | undefined): boolean => {
  if (availability == null || availability === '') return false;
  const value = availability.trim();
  return (
    value === 'CANCELLED' || value === INV_AVAILABILITY_WRITE_OFF_LABEL || value === 'Cancelado'
  );
};

/** Gestión en almacén: bloqueo solo en piezas UNASSIGNED (no en tránsito). */
export const isEligibleForWarehouseBlock = (placementStatusLabel: string): boolean =>
  placementStatusLabel === INV_STATUS_WAREHOUSE_LABEL;

/** Almacén + tránsito (p. ej. filtros KPI / listado). */
export const isWarehouseOrTransitPlacement = (placementStatusLabel: string): boolean =>
  placementStatusLabel === INV_STATUS_WAREHOUSE_LABEL ||
  placementStatusLabel === 'En Transito' ||
  placementStatusLabel === 'En tránsito';

/** Gestión en almacén: checkbox/transferencia solo en almacén, disponible (no bloqueada, no en tránsito). */
export const isSelectableForWarehouseTransfer = (item: {
  status: string;
  availabilityStatus: string;
}): boolean =>
  item.status === INV_STATUS_WAREHOUSE_LABEL && item.availabilityStatus === 'Disponible';
